import {
  resolutionsConstants
} from './constants'
import api from './api'
import {
  defAction
} from '../../../../helpers/defaultAction'
import downloadFile from "../../../../helpers/downloadFile";

export const resolutionsActions = {
  //resolutionActions
  createResolution, //Создание резолюции
  signResolution, // Подпись резолюции
  editResolution, // Редактирование резолюции
  editResolutionProject, // Редактирование проекта резолюции
  getResolutions, // Получение списка резолюций
  clearResolutionList, // Очистка списка резолюций
  getResolutionForm, // Получение данных для модалок резолюции
  clearResolutionForm, // Очистка данных для модалок резолюции
  clearResolutionActionsResult, //Очистка данных о результате выпонения действия над резолюцией
  downloadResolutionFile, // Скачать файл резолюции
  getResolutionChangeHistory, // Получение истории изменения резолюций
  deleteResolution, // Удаление резолюции
  declineResolution, // Отклонение резолюции
  getResolutionFilesInfo, // Получение списка объектов файлов резолюции для форм подписания и редактирования
  clearResolutionFilesInfo, // Очистка списка объектов файлов резолюции для форм подписания и редактирования

  //resolutionInfoActions
  getResolutionInfo, // Получение основной информации по резолюции
  clearResolutionInfo, // Очистка основной информации по резолюции

  //resolutionExecutorResultActions
  getResolutionExecutorsList, // Получение списка исполнителей с их ответами
  clearResolutionExecutorsList, // Очистка списка исполнителей с их ответами
  createExecutionResult, // Добавление ответа исполнителя
  updateExecutionResult, // Изменение ответа исполнителя
  approveExecutionResult, // Принять результат исполнителя
  declineExecutionResult, // Отклонить результат исполнителя
  clearResolutionExecutorResultActionsResult, // Очистка данных о результате выпонения действия над результатом исполнителя

  //resolutionSummaryResultActions
  getResolutionSummaryResult, // Получение сводного результата
  clearResolutionSummaryResult, // Очистка сводного результата
  createSummaryResult, // Добавление сводного результата резолюции
  updateSummaryResult, // Изменение сводного результата резолюции
  sendSummaryResultToSign, // Направление сводного результата на подпись
  sendSummaryResultForRevision, // Направление сводного результата на доработку
  signSummaryResult, // Подпись сводного результата ( завершение резолюции )
  getSummaryResultFilesInfo, // Получение base64 файлов сводного результата для подписания 
  clearSummaryResultFilesInfo, // Очистка base64 файлов сводного результата для подписания
  clearResolutionSummaryResultActionsResult, // Очистка данных о результате выпонения действия над сводным результатом резолюции

  //intermediateAppealResultActions
  getIntermediateAppealResultsPaged, // Получения списка промежуточных результатов обращения
  clearIntermediateAppealResultsPaged, // Очистка списка промежуточных результатов обращения
  getIntermediateAppealResult, // Получения промежуточного результата обращения
  clearIntermediateAppealResult, // Очистка промежуточного результата обращения
  createIntermediateAppealResult, // Добавление промежуточного результата обращения
  updateIntermediateAppealResult, // Изменение промежуточного результата обращения
  sendIntermediateAppealResultForRevision, // Направление промежуточного результата обращения на доработку
  signIntermediateAppealResult, //  Подпись промежуточного результата обращения
  clearIntermediateAppealResultActionsResult, // Очистка данных о результате выпонения действия над промежуточным результатом исполнения обращения
  getIntermediateAppealResultFilesInfo, // Получение base64 файлов промежуточного результата для подписания 
  clearIntermediateAppealResultFilesInfo, // Очистка base64 файлов промежуточного результата для подписания
}

//#region  Resolution
function getResolutions(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetResolutions,
    service: {
      func: api.GetResolutions,
      params: params
    },
  }
  return defAction(dispatchObj)
}

function clearResolutionList(){
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetResolutions.CLEAR
    })
}

function getResolutionForm(params){
  const dispatchObj = {
    constants : resolutionsConstants.GetResolutionForm,
		service   : {
      func   : api.GetResolutionForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearResolutionForm(){
  return(dispatch) => 
    dispatch({
      type: resolutionsConstants.GetResolutionForm.CLEAR
    })
}

function createResolution(params, isProject = false) {
  const dispatchObj = {
    constants: resolutionsConstants.CreateResolution,
    sucParams: {
      isProject : isProject
    },
    service: {
      func: api.CreateResolution,
      params: params,
    }
  }
  return defAction(dispatchObj)
}
  
function editResolution(params) {
  const dispatchObj = {
    constants: resolutionsConstants.EditResolution,
    service: {
      func: api.EditResolution,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function editResolutionProject(params) {
  const dispatchObj = {
    constants: resolutionsConstants.EditResolutionProject,
    service: {
      func: api.EditResolutionProject,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function signResolution(params) {
  const dispatchObj = {
    constants: resolutionsConstants.SignResolution,
    service: {
      func: api.SignResolution,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function downloadResolutionFile(params, file) {
  const dispatchObj = {
    constants: resolutionsConstants.DownloadResolutionFile,
    service: {
      func: api.DownloadResolutionFile,
      params: params,
    },
    sucFunction: (response) => downloadFile(response, file),
  }
  return defAction(dispatchObj)
}

function deleteResolution(params, isProject = false) {
  const dispatchObj = {
    constants: resolutionsConstants.DeleteResolution,
    sucParams: {
      isProject : isProject
    },
    service: {
      func: api.DeleteResolution,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function declineResolution(params) {
  const dispatchObj = {
    constants: resolutionsConstants.DeclineResolution,
    service: {
      func: api.DeclineResolution,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function getResolutionChangeHistory(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetResolutionChangeHistory,
    service: {
      func: api.GetResolutionChangeHistory,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function getResolutionFilesInfo(params, isEdit = false){
  const dispatchObj = {
    sucParams: {
      isEdit: isEdit
    },
    constants : resolutionsConstants.GetResolutionFilesInfo,
    service   : {
      func   : api.GetResolutionFilesInfo,
      params : params
    }
  }
  return defAction(dispatchObj)
}

function clearResolutionFilesInfo(){
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetResolutionFilesInfo.CLEAR,
    })
}

function clearResolutionActionsResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.ClearResolutionActionsResult,
    })
}
//#endRegion

//#region ResolutionInfo
function getResolutionInfo(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetResolutionInfo,
    service: {
      func: api.GetResolutionInfo,
      params: params,
    },
  }
  return defAction(dispatchObj)
}

function clearResolutionInfo() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetResolutionInfo.CLEAR,
    })
}
//#endRegion

//#region ExecutorResult
function getResolutionExecutorsList(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetResolutionExecutorsList,
    service: {
      func: api.GetResolutionExecutorsList,
      params: params,
    }
  }
  return defAction(dispatchObj)
}
  
function clearResolutionExecutorsList() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetResolutionExecutorsList.CLEAR,
    })
}

function createExecutionResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.CreateExecutionResult,
    service: {
      func: api.CreateExecutionResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function updateExecutionResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.UpdateExecutionResult,
    service: {
      func: api.UpdateExecutionResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function approveExecutionResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.ApproveExecutionResult,
    service: {
      func: api.ApproveExecutionResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function declineExecutionResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.DeclineExecutionResult,
    service: {
      func: api.DeclineExecutionResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function clearResolutionExecutorResultActionsResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.ClearResolutionExecutorResultActionsResult,
    })
}    
//#endRegion  

//#region SummaryResult
function getResolutionSummaryResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetResolutionSummaryResult,
    service: {
      func: api.GetResolutionSummaryResult,
      params: params,
    }
  }
  return defAction(dispatchObj)
}
    
function clearResolutionSummaryResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetResolutionSummaryResult.CLEAR,
    })
}

function createSummaryResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.CreateSummaryResult,
    service: {
      func: api.CreateSummaryResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function updateSummaryResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.UpdateSummaryResult,
    service: {
      func: api.UpdateSummaryResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function sendSummaryResultToSign(params){
  const dispatchObj = {
    constants: resolutionsConstants.SendSummaryResultToSign,
    service: {
      func: api.SendSummaryResultToSign,
      params
    }
  }
  return defAction(dispatchObj)
}

function sendSummaryResultForRevision(params){
  const dispatchObj = {
    constants: resolutionsConstants.SendSummaryResultForRevision,
    service: {
      func: api.SendSummaryResultForRevision,
      params
    }
  }
  return defAction(dispatchObj)
}

function getSummaryResultFilesInfo(params){
  const dispatchObj = {
    constants: resolutionsConstants.GetSummaryResultFilesInfo,
    service: {
      func: api.GetSummaryResultFilesInfo,
      params
    }
  }
  return defAction(dispatchObj)
}

function clearSummaryResultFilesInfo(){
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetSummaryResultFilesInfo.CLEAR,
    })
}

function signSummaryResult(params){
  const dispatchObj = {
    constants: resolutionsConstants.SignSummaryResult,
    service: {
      func: api.SignSummaryResult,
      params
    }
  }
  return defAction(dispatchObj)
}

function clearResolutionSummaryResultActionsResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.ClearResolutionSummaryResultActionsResult,
    })
}
//#endRegion

//#region IntermediateResult
function getIntermediateAppealResultsPaged(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetIntermediateAppealResultsPaged,
    service: {
      func: api.GetIntermediateAppealResultsPaged,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function getIntermediateAppealResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.GetIntermediateAppealResult,
    service: {
      func: api.GetIntermediateAppealResult,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function createIntermediateAppealResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.CreateIntermediateAppealResult,
    service: {
      func: api.CreateIntermediateAppealResult,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function updateIntermediateAppealResult(params) {
  const dispatchObj = {
    constants: resolutionsConstants.UpdateIntermediateAppealResult,
    service: {
      func: api.UpdateIntermediateAppealResult,
      params: params,
    }
  }
  return defAction(dispatchObj)
}
 
function sendIntermediateAppealResultForRevision(params){
  const dispatchObj = {
    constants: resolutionsConstants.SendIntermediateAppealResultForRevision,
    service: {
      func: api.SendIntermediateAppealResultForRevision,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function signIntermediateAppealResult(params){
  const dispatchObj = {
    constants: resolutionsConstants.SignIntermediateAppealResult,
    service: {
      func: api.SignIntermediateAppealResult,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function getIntermediateAppealResultFilesInfo(params){
  const dispatchObj = {
    constants: resolutionsConstants.GetIntermediateAppealResultFilesInfo,
    service: {
      func: api.GetIntermediateAppealResultFilesInfo,
      params: params,
    }
  }
  return defAction(dispatchObj)
}

function clearIntermediateAppealResultsPaged() {
return (dispatch) =>
  dispatch({
    type: resolutionsConstants.GetIntermediateAppealResultsPaged.CLEAR,
  })
}

function clearIntermediateAppealResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetIntermediateAppealResult.CLEAR,
    })
  }

function clearIntermediateAppealResultFilesInfo() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.GetIntermediateAppealResultFilesInfo.CLEAR,
    })
  }

function clearIntermediateAppealResultActionsResult() {
  return (dispatch) =>
    dispatch({
      type: resolutionsConstants.ClearIntermediateAppealResultActionsResult,
    })
}
//#endRegion